import React from "react";
import styled from "theme/libs/styled";

const Div = styled("div")`
    height: ${({ theme }) => theme.variables.headerHeight}px;
    margin-bottom: 40px;
`;

const HeroPlaceholder = () => {
    return <Div />;
};

export default HeroPlaceholder;
